import React from "react";
import SmallSlidePanel from "../Modals/add_customer/SmallSlidePanel";

const CloseAccountSuccess = ({
  closeAccountSuccessOpen,
  handleCloseAccountSuccess,
}) => {
  return (
    <SmallSlidePanel
      isOpen={closeAccountSuccessOpen}
      onClose={handleCloseAccountSuccess}
      width={500}
      showCloseButton={false}
    >
      <div className="h-[300px] w-full flex flex-col gap-[40px] items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="110"
          height="110"
          viewBox="0 0 110 110"
          fill="none"
        >
          <circle cx="55" cy="55" r="55" fill="#074073" />
          <path
            d="M19.5 57L39.5 74.0514L88.5 29.5"
            stroke="white"
            strokeWidth="5"
          />
        </svg>

        <p>Success! Member deleted successfully.</p>
      </div>
    </SmallSlidePanel>
  );
};

export default CloseAccountSuccess;
